{
  "nl": {
    "task_assignment": {
      "actions": {
        "add_assignee": "Toegewezene toevoegen",
        "bulk_remove": "Verwijderen",
        "confirm": "Markeren als afgerond",
        "delete": "Toegewezene verwijderen",
        "document_add": "Bestand toevoegen",
        "document_delete": "Verwijderen",
        "due_in_month": "Over een maand",
        "due_in_two_weeks": "Over twee weken",
        "due_in_week": "Over een week",
        "due_remove": "Deadline verwijderen",
        "open": "Openen",
        "reopen": "Heropenen",
        "selectAll": "Selecteer alle {total}",
        "send_and_notify": "Versturen en verwittigen",
        "set_due_date": "Deadline instellen",
        "set_status": "Status instellen",
        "show_more": "Nog {count} open taak tonen | Nog {count} open taken tonen",
        "show_more_completed": "Nog {count} afgeronde taak tonen | Nog {count} afgeronde taken tonen",
        "unSelectAll": "Selectie opheffen",
        "upload_files": "{count} bestand uploaden | {count} bestanden uploaden"
      },
      "assignee_scopes": {
        "external": "Extern",
        "internal": "Intern"
      },
      "assignee_types": {
        "customer": "Klant",
        "employee": "Teamlid",
        "partner": "Partner"
      },
      "attributes": {
        "assignee": "Toegewezene",
        "assignees": "Toegewezenen",
        "comment": "Opmerking",
        "created_at": "Aangemaakt",
        "document": "Document",
        "due_date": "Deadline",
        "project": "Project",
        "status": "Status",
        "task": "Taak",
        "unit": "Unit"
      },
      "confirm": {
        "assignees_count": "{count} toegewezene | {count} toegewezenen",
        "bulk_delete_accept": "Verwijderen",
        "bulk_delete_body": "Dit verwijdert hun taak voor die units. De taak zelf en de andere toegewezenen behouden de hunne.",
        "bulk_delete_body_project": "Dit verwijdert hun taak. De taak zelf en de andere toegewezenen behouden de hunne.",
        "bulk_delete_header": "Verwijder {count} toegewezene? | Verwijder {count} toegewezenen?",
        "complete_accept": "Alles afronden",
        "complete_body": "Dit zet {assignees} op {status}, ook de taken die de klant zelf nog niet afgerond heeft. Ze verhuizen in hun lijst naar de afgeronde taken.",
        "complete_header": "Alles op afgerond zetten?",
        "customer_tasks": "{count} klantentaak | {count} klantentaken",
        "customers_and_team": "{customers} en {team}",
        "delete_body": "Dit verwijdert hun taak voor die unit. Andere units en toegewezenen behouden de hunne.",
        "delete_body_project": "Dit verwijdert hun taak. Andere toegewezenen behouden de hunne.",
        "delete_header": "Verwijder {name} uit {unit}?",
        "delete_header_project": "Verwijder {name} uit deze taak?",
        "delete_sent_customers": "Deze was al verstuurd, dus ze verdwijnt ook uit het portaal van de klanten.",
        "delete_sent_team": "Deze was al verstuurd, dus ze verdwijnt ook uit de lijst van {name}.",
        "document_delete_body": "Het bestand verdwijnt ook uit de documenten van de unit.",
        "document_delete_body_project": "Het bestand verdwijnt ook uit de documenten van het project.",
        "document_delete_header": "Dit bestand verwijderen?",
        "draft_accept": "Alles op concept zetten",
        "draft_body": "Dit zet {assignees} terug op {status}. De taak verdwijnt uit de lijst van de klant tot je ze opnieuw verstuurt. Al verstuurde e-mails blijven verstuurd.",
        "draft_header": "Alles terug naar concept?",
        "send_body": "Dit zet {who} op {status}.",
        "send_customers": "Klanten zien de taak meteen in hun portaal en krijgen er een e-mail over.",
        "send_header": "Verstuur deze taak? | Verstuur deze taken?",
        "send_permanent": "Je kan ze later terugzetten op Concept, maar de melding is dan al verstuurd.",
        "send_team": "Teamleden zien de taak op hun dashboard en krijgen een melding.",
        "tasks_count": "{count} taak | {count} taken",
        "team_tasks": "{count} teamtaak | {count} teamtaken"
      },
      "deep_link": {
        "completed": "Deze taak is al afgerond.",
        "gone": "Deze taak is niet meer open."
      },
      "empty": {
        "filtered_description": "Pas je filters aan of wis ze om alle toewijzingen te zien.",
        "filtered_title": "Geen toewijzingen komen overeen met je filters",
        "none_title": "Geen toewijzingen"
      },
      "filters": {
        "assignee_any": "Elke toegewezene",
        "clear_all": "Alle filters wissen",
        "done": "Klaar",
        "due_window_values": {
          "none": "Geen deadline",
          "overdue": "Te laat",
          "set": "Heeft een deadline"
        },
        "phase_any": "Elke fase",
        "show_only": "Toon enkel",
        "show_only_values": {
          "customers": "Klanten",
          "mine": "Aan mij toegewezen",
          "team": "Team"
        },
        "unit_any": "Elke unit"
      },
      "labels": {
        "add_assignee": "Een toegewezene toevoegen",
        "add_customers": "Klanten toevoegen",
        "already_assigned": "Deze taak is al toegevoegd aan deze unit.",
        "already_assigned_project": "Deze taak is al toegevoegd aan dit project.",
        "assignees_subtitle": "Elk krijgt een eigen taak, per unit.",
        "assignees_title": "Wie moet het doen",
        "comment_add": "Een opmerking toevoegen",
        "comment_earlier_round": "eerdere ronde",
        "comment_placeholder": "Iets wat we moeten weten?",
        "comment_placeholder_upload": "Iets wat we moeten weten over deze documenten?",
        "comments_none": "De klant liet geen opmerking na.",
        "comments_title": "Opmerkingen bij deze taak",
        "completed": "Afgerond",
        "confirm_message": "Weet je zeker dat je deze taak als afgerond wilt markeren?",
        "customers": "Klanten",
        "documents_none": "Er is nog niets geüpload.",
        "documents_title": "Bestanden bij deze taak",
        "earlier": "+{count} eerder",
        "my_tasks": "Mijn taken",
        "no_assignees": "Nog geen toegewezenen.",
        "no_assignments": "Taken die aan jou toegewezen worden, verschijnen hier.",
        "no_assignments_task": "Nog geen toewijzingen voor deze taak.",
        "previous_upload": "Eerdere upload",
        "required": "Dit veld is verplicht",
        "section_completed": "Afgerond",
        "section_open": "Open",
        "selectOne": "Selecteer minstens één taak.",
        "select_task": "Selecteer een taak",
        "selected": "{selected} geselecteerd | {selected} geselecteerd",
        "set_status_for": "Status instellen voor {name}",
        "status_hint_assignees": "de toegewezene | de toegewezenen",
        "status_hint_customer": "de klant",
        "status_hint_sent": "de toegewezenen naar wie ze verstuurd is",
        "superseded": "Vervangen",
        "totalSelected": "Alle {total} geselecteerd",
        "upload_hint": "Upload het gevraagde document of de gevraagde documenten om deze taak te voltooien."
      },
      "status_hints": {
        "completed": "De taak is afgerond. Ze blijft zichtbaar voor {who}, onder {completed}.",
        "draft": "Nog niet zichtbaar voor {who}. Zet de taak op {open} om ze te delen.",
        "requested": "Zichtbaar voor {who}. De taak moet nog afgerond worden."
      },
      "statuses": {
        "completed": "Afgerond",
        "draft": "Concept",
        "requested": "Open"
      },
      "toasts": {
        "bulk_delete": "Taken verwijderd",
        "bulk_update": "Taken bijgewerkt",
        "completed": "Taak afgerond",
        "create": "Taak aangemaakt",
        "delete": "Toegewezene verwijderd",
        "document_added": "Bestand toegevoegd",
        "document_deleted": "Bestand verwijderd",
        "reopened": "Taak heropend",
        "update": "Taak bijgewerkt"
      }
    }
  }
}
